import { render } from "./DowntimeReasonDialog.vue?vue&type=template&id=b52beb98&scoped=true"
import script from "./DowntimeReasonDialog.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonDialog.vue?vue&type=script&lang=js"

import "./DowntimeReasonDialog.vue?vue&type=style&index=0&id=b52beb98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52beb98"]])

export default __exports__